module.exports = __webpack_public_path__ + "static/media/map_marker.197b4cd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/map_marker.svg
// module id = 1846
// module chunks = 0